import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20Korean%20manhwa%20style%20illustration%20with%20warm%20gradient%20background%2C%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20soft%20watercolor%20textures%2C%20dreamy%20atmosphere%2C%20warm%20pink%20peach%20and%20cream%20tones%2C%20abstract%20geometric%20patterns%2C%20artistic%20composition%2C%20clean%20and%20modern%20aesthetic&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫在线观看 - 免费漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="韩漫在线观看 - 免费漫画下拉式阅读"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-5 leading-tight">
          韩漫在线观看
          <span className="block text-xl md:text-2xl lg:text-3xl mt-3 font-body font-light text-white/90">
            免费漫画下拉式阅读 · 畅享韩漫世界
          </span>
        </h1>
        <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          韩漫漫画网站为您提供稳定流畅的漫画网址服务，海量韩漫资源每日更新。支持免费漫画下拉式阅读，
          无需翻页即可沉浸式享受韩漫在线观看体验，让您的阅读之旅顺畅无阻。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white rounded-full font-label text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-read-line" style={{ width: '18px', height: '18px' }}></i>
            开始阅读
          </Link>
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-label text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line" style={{ width: '18px', height: '18px' }}></i>
            热门推荐
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-white/60 text-lg" style={{ width: '20px', height: '20px' }}></i>
        </div>
      </div>
    </section>
  );
}